module.exports = __webpack_public_path__ + "static/media/methodology.da78c99c.svg";